import SkeletonTable from "@/components/SkeletonTable"
import { getMasterSystem } from "@/services/getData"
import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"

export default function SettingSystemPage() {
  const { data, isPending } = useQuery({
    queryKey: ["masterSystem"],
    queryFn: getMasterSystem,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
